var _a;
export const GLOBAL_TINI = ((_a = globalThis).TiniJS || (_a.TiniJS = {}));
export const THEME_CHANGE_EVENT = 'tini:theme-change';
//# sourceMappingURL=consts.js.map